import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { buttonColor, onControlClick, cmsColorConfig, listOnSelect } from '../../JS/setColors'
import { setCurtain, dimCurtain, listCurtains, zoneName } from '../../config/constant'
import { changeCurtain, VDAStatusApi, setCurrentCurtain, setSelectedControlZone } from '../../action/roomControlAction'
import CurtainZoneSelector from './curtainZoneSelector'

class CurtainControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentCurtain: null,
            SessionToken: localStorage.getItem("GuestJourneySessionToken"),
            zoneCount: 0
        }
        this.timer = null
    }

    componentDidMount() {
        let count = 0, curtainZone
        // buttonColor(this.props.menuColor);
        this.setState({ currentCurtain: this.props.currentCurtain });
        // onControlClick(this.props.currentCurtain, "curtains", this.props.menuColor);
        cmsColorConfig(this.props.menuColor);
        if (this.props.VDAZoneList.length > 0) {
            console.log("curtain coount")
            this.props.VDAZoneList.map((iterator) => {
                if (iterator.curtainCount > 0) {

                    count++;
                    curtainZone = iterator
                }
            })
            if (count === 1) {
                this.props.setSelectedControlZone(curtainZone);
                this.setState({ zoneCount: 1 });
            }
        }
    }

    VDAStatusCallBack = (status) => {
        if (status) {
            if (this.props.curatinList.length > 0) {
                this.props.curatinList.map((iterator, index) => {
                    if (iterator.label) {
                        // if (iterator.value === "ON") {
                        //     this.props.setCurrentCurtain(`curtain${iterator.id}${iterator.value}`);
                        // } else {
                        //     this.props.setCurrentCurtain(null);
                        // }
                    }
                    // if (index < 2) {
                    //     for (let i = 0; i < this.props.curatinList.length; i++) {
                    //         if (this.props.curatinList[i][`curtain${index + 1}`]) {
                    //             console.log("id", this.props.curatinList[i][`curtain${index + 1}`]);
                    //             if (this.props.curatinList[i][`curtain${index + 1}`].value === "ON") {
                    //                 this.props.setCurrentCurtain(`${this.props.curatinList[i][`curtain${index + 1}`].name}ON`);
                    //             }
                    //         }
                    //     }
                    // }
                })
            }
        }
    }

    VDAApiCall = () => {
        //we have set this time out to make sure that we hit the status API after we hit the sendCommand
        window.clearInterval(this.timer);
        this.timer = window.setTimeout(() => {
            //console.log("this.state.SessionToken", this.state.SessionToken);
            this.props.VDAStatusApi(
                this.state.SessionToken, this.props.guestDetail,
                this.VDAStatusCallBack, zoneName
            );
        }, 3000);
    }

    buttonClick = (curtain, mode, status, zone) => {
        let action;
        //onControlClick(`curtain${curtain.id}${status}`, mode, this.props.menuColor);
        this.setState({ currentCurtain: `curtain${zone}${curtain.id}${status}` });
        if (status === "OFF") {
            action = dimCurtain
        } else {
            action = setCurtain
        }
        this.props.changeCurtain(`curtain${curtain.id}`, action, this.props.guestDetail, status, zone);
        //this.VDAApiCall();
    }

    componentDidUpdate(preProps) {
        console.log("componentDidUpdate", this.props.currentCurtain, preProps.currentCurtain, this.state.currentCurtain)
        if (this.props.currentCurtain !== preProps.currentCurtain) {
            if (this.state.currentCurtain !== this.props.currentCurtain) {
                // this.setState({
                //     currentCurtain: this.props.currentCurtain,
                // })
                //onControlClick(this.props.currentCurtain, "curtains", this.props.menuColor);
            }
        }
        listOnSelect(this.props.menuColor);
    }
    componentWillUnmount() {
        this.props.setSelectedControlZone({});
    }

    backButton = () => {
        this.props.setSelectedControlZone({});
    }

    render() {
        return (
            <div id="controls-curtain" className="rc-controls w-100">
                <CurtainZoneSelector />
                <div
                    style={this.props.selectedControlZone.zoneId ? {} : { display: "none" }}>
                    {/* <h2>Curtain controls</h2> */}
                    <button class="return-button"
                        data-target="ac-selection"
                        style={this.props.VDAZoneList.length === 1 || this.state.zoneCount === 1 ? { display: "none" } : {}}
                        onClick={() => { this.backButton() }}>
                        Back to selection
                    </button>
                    <p>Open or close the curtains / blinds</p>
                    {
                        this.props.selectedControlZone.curtainScenes ?
                            // this.props.VDAZoneList.map((iter) => {
                            //     return (
                            this.props.selectedControlZone.curtainScenes.map((iterator, curtainIndex) => {
                                if (curtainIndex < this.props.selectedControlZone.curtainCount) {
                                    return (
                                        // <div class="controls"
                                        //     style={{
                                        //         position: "relative", margin: "1rem 0", paddingTop: "1rem",
                                        //         borderTop: "1px solid #999", height: "4rem"
                                        //     }}>
                                        //     <p style={{
                                        //         marginBottom: 0, marginRight: "1rem",
                                        //         marginTop: "0.75rem", display: "inline-block"
                                        //     }}>
                                        //         <strong>{iterator.label}</strong></p>
                                        //     <label class="switch" style={{ position: "absolute", right: "1rem" }}>
                                        //         <input id={`curtain${iterator.id}${iterator.value}`} type="checkbox" class="use-all-toggle" onClick={() => { this.buttonClick(iterator, "curtains") }} />
                                        //         <span class="slider round"></span>
                                        //     </label>
                                        // </div>
                                        <div>
                                            <button
                                                id={`curtain${this.props.selectedControlZone.zoneId}${iterator.id}ON`}
                                                onClick={() => { this.buttonClick(iterator, "curtains", "ON", this.props.selectedControlZone.zoneId) }}
                                                className={
                                                    this.state.currentCurtain === `curtain${this.props.selectedControlZone.zoneId}${iterator.id}ON` ?
                                                        "button selected w-100" : "button w-100"
                                                }>
                                                <i className="fa fa-map-o" style={{ color: "inherit" }}></i>
                                                {` ${iterator.label ? iterator.label : "curtain"} Open`}
                                            </button>
                                            <button
                                                id={`curtain${this.props.selectedControlZone.zoneId}${iterator.id}OFF`}
                                                onClick={() => { this.buttonClick(iterator, "curtains", "OFF", this.props.selectedControlZone.zoneId) }}
                                                className={
                                                    this.state.currentCurtain === `curtain${this.props.selectedControlZone.zoneId}${iterator.id}OFF` ?
                                                        "button selected w-100" : "button w-100"
                                                }>
                                                <i className="fa fa-map-o" style={{ color: "inherit" }}></i>
                                                {` ${iterator.label ? iterator.label : "curtain"} Close`}
                                            </button>
                                        </div>
                                    )
                                }
                                //     })
                                // )
                            }) : null
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentControl: state.store.roomControl.currentControl,
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        currentCurtain: state.store.roomControl.currentCurtain,
        curatinList: state.store.roomControl.curatinList,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        selectedControlZone: state.store.roomControl.selectedControlZone
    }
}

export default connect(
    mapStateToProps,
    {
        changeCurtain,
        VDAStatusApi,
        setCurrentCurtain,
        setSelectedControlZone
    }
)(CurtainControl);
